import React, { createContext, FC, useState } from 'react';

interface MobileMenuContextValue {
  isCategoriesMenuOpen: boolean;
  toggleCategoriesMenu: (isOpen: boolean) => void;
  isTopBarSticky: boolean;
  toggleTopBarSticky: (isSticky: boolean) => void;
}

const TemplatesPageUIContext = createContext<MobileMenuContextValue>({
  isCategoriesMenuOpen: false,
  toggleCategoriesMenu: () => {},
  isTopBarSticky: false,
  toggleTopBarSticky: () => {},
});

export const TemplatesPageUIProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isCategoriesMenuOpen, setIsCategoriesMenuOpen] = useState(false);
  const [isTopBarSticky, setIsTopBarSticky] = useState(false);

  const toggleCategoriesMenu = (isOpen: boolean) =>
    setIsCategoriesMenuOpen(isOpen);

  const toggleTopBarSticky = (isSticky: boolean) => setIsTopBarSticky(isSticky);

  return (
    <TemplatesPageUIContext.Provider
      value={{
        isCategoriesMenuOpen,
        toggleCategoriesMenu,
        isTopBarSticky,
        toggleTopBarSticky,
      }}
    >
      {children}
    </TemplatesPageUIContext.Provider>
  );
};

export const useTemplatesPageUI = () => {
  const context = React.useContext(TemplatesPageUIContext);
  if (!context) {
    throw new Error(
      'useTemplatesPageUI must be used within a TemplatesPageUIProvider',
    );
  }

  return context;
};
